import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetCategories, actionDeleteCategory } from "../../actions/RestaurantActions"
import { LOGIN_ROUTE, MENU_CATEGORY_ADD_ROUTE, MENU_CATEGORY_EDIT_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle, 
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibleIcon from '@material-ui/icons/Visibility';
import HideIcon from '@material-ui/icons/VisibilityOff';
import VisibleTDIcon from '@material-ui/icons/Check';
import HideTDIcon from '@material-ui/icons/Close';
import ColorIcon from '@material-ui/icons/FiberManualRecord';
import SuggestIcon from '@material-ui/icons/StarRate';
import Util, { ERROR, INFO } from '../../common/Util'
import Roles from "../../config/RolesConstants"


class MenuCategories extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:25, count:0, tickets:[], filter:"", ticketForDelete:false, canAddEditOrDelete:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteCategorySuccess=this.getDeleteCategorySuccess.bind(this)
    this.onAddCategory=this.onAddCategory.bind(this)
    this.onConfirmDeleteCategory=this.onConfirmDeleteCategory.bind(this)
    this.onSearch=this.onSearch.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    let canAddEditOrDelete = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN || r.id==Roles.ADMIN})>=0)
    this.setState({canAddEditOrDelete:canAddEditOrDelete})
    this.props.actionGetCategories(this.onChangePage, this.getCategoryError)
  }

  getCategoryError(e){
    console.log("ERROR AL LISTAR LAS CATEGORIAS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las categorías.")
  }

  onSearch(evt){
    this.setState({filter:evt.target.value}, this.onChangePage)
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let categories = this.props.categoryList.filter((c)=>{return c.id.match(filter)})
    let count = categories.length
    categories=categories.slice(from, end)
    this.setState({page:newPage, count:count, categories:categories})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let categories = this.props.categoryList.filter((c)=>{return c.id.match(filter)})
    let count = categories.length
    categories=categories.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, categories:categories})
  }

  onAddCategory(){
    this.props.history.push(MENU_CATEGORY_ADD_ROUTE)
  }

  onEditCategory(category){
    this.props.history.push(MENU_CATEGORY_EDIT_ROUTE, category)
  }

  onConfirmDeleteCategory(){
    this.props.actionDeleteCategory(this.state.categoryForDelete,this.getDeleteCategorySuccess,this.getDeleteCategoryError)
    this.setState({categoryForDelete:false})
  }

  onDeleteCategory(category){
    this.setState({categoryForDelete:category})
  }

  getDeleteCategorySuccess(){
    const restaurant = this.props.restaurant
    // console.log("RESTAURANT", restaurant)
    this.props.actionGetCategories(()=>{this.onChangePage(null,this.state.page)}, this.getCategoryError)
  }

  getDeleteCategoryError(e){
    console.log("ERROR GET DELETE TICKET", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, e.statusText||"Ocurrió un error al elminar la categoría.")
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Nro. de Orden",  "Ícono", "Nombre"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let categories = this.state.categories
    
    if(!categories||categories.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return categories.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.catOrder}</TableCell>
          <TableCell>
            <img src={item.catImg} style={{height:37.5, objectFit:"contain"}}/>        
          </TableCell>
          <TableCell>{item.id}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title="Editar categoría de menú">
              <IconButton onClick={this.onEditCategory.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar categoría de menú">
              <IconButton onClick={this.onDeleteCategory.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, categoryList, restaurant } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">{restaurant.evtName}</Typography>
            <Typography variant="subtitle1">Crea categorías de menú para el comercio seleccionado</Typography>
          </Box>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de categorías de menú</Typography>
            {this.state.canAddEditOrDelete?
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear nueva categoría de menú">
                <Fab color="primary" onClick={this.onAddCategory} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
            :null}
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.categoryForDelete}>
            <DialogTitle>Eliminar Categoría</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar la categoría de menú?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({categoryForDelete:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Eliminar categoría de menú">
                <Button variant="contained" color="primary" onClick={this.onConfirmDeleteCategory}>Eliminar</Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    categoryList: store.evt.categoryList,
    restaurant: store.evt.restaurant,
    profile: store.auth.profile

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetCategories,
      actionDeleteCategory
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(MenuCategories)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/restaurants/MenuCategories.js